import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { TranslateService } from '@services/translate/translate.service';
import { PrivilegeGuard } from '../../../guards/privilege.guard';
import { PackageService } from '@services/packages/package.service';
import { MessengerService } from '@services/messenger/messenger.service';
import { DialogService } from '@services/dialog/dialog.service';
import { QueService } from '@services/que/que.service';

@Component({
    selector: 'app-packages',
    templateUrl: './packages.component.html',
    styleUrls: ['./packages.component.scss'],
    providers: [PackageService, QueService],
    standalone: false
})
export class PackagesComponent implements OnInit {

  public pageActions: PageAction[];

  public triggerAction$ = new BehaviorSubject<any>(false);

  public pages = [];
  public currentPage = { title: '', type: '' };
  public currentIndex = 0;
  public packageId;
  public myPackage;
  public isLoading;

  constructor(
    private router: Router, private activatedRoute: ActivatedRoute, private ts: TranslateService, private priv: PrivilegeGuard, private packageService: PackageService,
    private ms: MessengerService, private dialogService: DialogService, private que: QueService
  ) {
    this.packageId = this.activatedRoute.snapshot.params['id'];
  }

  async ngOnInit() {
    const check = await this.checkCustomer();
    if (!check) {
      this.dialogService.confirm('Invalid privileges');
      this.router.navigate(['dashboard']);
    }
    this.createPageActions();
    const translation = this.ts.get('packages');
    if (this.myPackage && this.myPackage.isScreenPackage) {
      this.pages = [
        { title: translation.installedApps.screenTitle, type: 'app-manager' },
        { title: translation.screen.images, type: 'screen' }
      ];
      if ((this.myPackage.ibexApp && this.myPackage.ibexApp.enabled) || (this.myPackage.ibexTouch && this.myPackage.ibexTouch.enabled)) {
        this.pages.push({ title: translation.legal.title, type: 'legal' });
      }
    } else {
      this.pages = [
        { title: translation.installedApps.title, type: 'app-manager' },
        { title: translation.images.title, type: 'images' }
      ];
    }
    if (this.priv.checkIfPrivilege('superadmin', 'packages')) {
      this.pages.push({ title: translation.config.title, type: 'meta-config' });
      this.pages.push({ title: 'ibexsmart', type: 'ibexsmart' });
      this.pages.push({ title: 'ibextouch', type: 'ibextouch' });
      this.pages.push({ title: 'ibextablet', type: 'ibextablet' });
      this.pages.push({ title: 'ibexinfo', type: 'ibexinfo' });
      this.pages.push({ title: 'ibextv', type: 'ibextv' });
      this.pages.push({ title: 'Logs', type: 'logs' });
    }
    if (!this.myPackage.tweebie.isDestination && !this.myPackage.isScreenPackage) {
      this.pages.push({ title: translation.detail.bookingLinkTitle, type: 'general' });
    }
  }

  async checkCustomer(): Promise<boolean> { // todo: checkCustomer is identical to package.guard - can be replaced with it!
    const currentOrg = this.ms.getOrganisation();
    const myPackage: any = await this.packageService.get(this.packageId).catch(err => {
      console.log('error on check customer: ', err);
      return false;
    });
    this.myPackage = myPackage;
    if (this.priv.checkIfPrivilege('superadmin', 'packages')) {
      return true;
    }
    if (!currentOrg || !myPackage || !myPackage.customerId) {
      return false;
    }
    if (currentOrg.ParentOrganisationID) {
      return this.myPackage.OwnerOrganisationID && this.myPackage.OwnerOrganisationID === currentOrg.OrganisationID;
    }
    return (currentOrg.ibex3customerId === myPackage.customerId || currentOrg.organisationCustomerId === myPackage.customerId);
  }

  tabChange($event) {
    this.currentIndex = $event.index;
    this.currentPage = this.pages[$event.index];
    this.triggerAction$.next(this.currentPage.type + '-reload');
  }

  getTitle() {
    return this.myPackage?.title?.replace('*S:', 'ibextouch').replace('*W:', 'tweebie ').replace('*A:', 'tweebie ');
  }

  private createPageActions(): void {
    this.pageActions = [
      new PageAction({
        icon: 'save', title: 'Save', hidden: !this.priv.checkIfPrivilege('write', 'packages'), callback: () => { this.triggerAction$.next(this.currentPage.type) }
      }),
      new PageAction({
        icon: 'language', title: '', translationString: 'general.queuePriority', hidden: !this.priv.checkIfPrivilege('write', 'packages'),
        callback: () => { this.que.triggerPriorities(this.packageId) }
      }),
      new PageAction({
        icon: 'subdirectory_arrow_left', title: 'Back', translationString: 'general.back', callback: () => { this.router.navigate(['packages']) }
      })
    ]
  }
}
